const riot = require('riot');

riot.tag2('module-news', '<div class="w-full bg-sub p32 text-whiter s-px16"><span>Link to </span><a class="text-link" href="https://lit.link/en/yohueno" target="_blank">lit.link</a></div>', 'module-news,[data-is="module-news"]{display:block}', '', function(opts) {
});
riot.tag2('item-news_', '<div class="relative mb32"> <div class="f"> <h3 class="w-full mb8 mr8 fs24">{opts.item.title}</h3> <time class="flex-fixed fs10">{dayjs(opts.item.updatedAt).format(\'YYYY/MM/DD\')}</time> </div> <div class="fs12 lh16 transition text-softgray {&quot;line-clamp-3&quot;: !isMore}" data-is="atom-anchorify" text="{opts.item.description}" ref="description" riot-style="height: {isMore ? getHeight(index) : 12 * 1.5 * 3}px;"> </div> <div class="mt10" onclick="{toggleRead}" if="{getHeight(index) &gt;= 12 * 1.6 * 3}"> <div class="cursor-pointer"> <p class="fs12 text-medium_emphasis text-center">{isMore ? ⁗close⁗ : ⁗more⁗}</p> </div> </div> </div>', 'item-news_,[data-is="item-news_"]{display:block}', '', function(opts) {
    this.on('mount', () => {
      this.isMore = false;
    });

    this.toggleRead = () => {
      this.isMore = !this.isMore;
      this.update();
    };

    this.getHeight = () => {
      if (!this.refs.description) return 0;
      return this.refs.description.root.scrollHeight;
    };
});